import React from 'react';
import Row from './Row';
import T from 'i18n-react';
import Grid from '@material-ui/core/Grid';
import AppContainer from '../Container/AppContainer';
import type {
  ArticleCategoryProps,
  ArticleProps,
} from '../../core/Articles/props';
import Title from '../../core/News/components/Title';
import SelectGrid from '../../core/News/components/SelectGrid';
import Pagination from '../../core/News/components/Pagination';
import Select from '../../core/News/components/Select';
import { NEWS } from '../routing';

type NewsIndexProps = {
  totalPages: number,
  news: Array<ArticleProps>,
  categories: Array<ArticleCategoryProps>,
};

const NewsIndex = ({ totalPages, news, categories }: NewsIndexProps) => {
  const [years] = React.useState(() => {
    const currentYear = new Date().getFullYear();

    let years = [];
    for (let i = currentYear; i >= 2018; i--) {
      years.push(i);
    }
    return years;
  });

  const location = window.location;

  const searchParams = new URLSearchParams(location.search);

  const getYear = () => {
    const year = searchParams.get('year');
    return parseInt(year) || '';
  };

  const getCategory = () => {
    const categoryId = searchParams.get('category');
    return parseInt(categoryId) || '';
  };

  const handleChange = (param) => (event) => {
    const params = new URLSearchParams(location.search);
    if (event.target.value) {
      params.set(param, event.target.value);
    } else {
      params.delete(param);
    }
    params.delete('page');
    const query = params.toString();
    window.location.href = location.pathname + (query ? `?${query}` : '');
  };

  const yearChoices = React.useMemo(
    () => years.map((y) => ({ text: y, value: y })),
    [years],
  );
  const categoryChoices = React.useMemo(
    () => categories.map((c) => ({ text: c.name, value: c.id })),
    [categories],
  );

  return (
    <AppContainer maxWidth="md">
      <Title>{T.translate('title.news.index')}</Title>
      <SelectGrid container spacing={2} justify="flex-end">
        <Grid item xs={6} sm="auto">
          <Select
            choices={yearChoices}
            initialValue={getYear()}
            labelId="news-year"
            label={T.translate('year')}
            onChange={handleChange('year')}
          />
        </Grid>
        <Grid item xs={6} sm="auto">
          <Select
            choices={categoryChoices}
            initialValue={getCategory()}
            labelId="news-category"
            label={T.translate('category')}
            onChange={handleChange('category')}
          />
        </Grid>
      </SelectGrid>
      {news?.map?.((n, index, array) => (
        <Row
          key={index}
          {...n}
          href={NEWS.replace(':id', n.id)}
          border={index === array.length - 1}
        />
      ))}
      <Pagination count={totalPages} />
    </AppContainer>
  );
};

export default NewsIndex;
